function updateModalFlags(state, flagChanges) {
  const newState = {
    ...state,
  };
  const newFlags = {
    ...state.flags,
  };
  const flagChangeEntries = Object.entries(flagChanges);
  const changeToCloseEntries = flagChangeEntries.filter(([modalId, flagValue]) => !flagValue);
  const changeToOpenEntries = flagChangeEntries.filter(([modalId, flagValue]) => flagValue);

  changeToCloseEntries.forEach((flagChange) => {
    const [modalId] = flagChange;

    if (newFlags[modalId]) {
      newFlags[modalId] = false;
      newState.openModalCount -= 1;
    }

    if (newState.modalQueue.size > 0 && newState.openModalCount < newState.maxOpenModalLimit) {
      const queuedModalName = newState.modalQueue.last();

      newState.modalQueue = newState.modalQueue.dequeue();

      newFlags[queuedModalName] = true;
      newState.openModalCount += 1;
    }
  });

  changeToOpenEntries.forEach((flagChange) => {
    const [modalId] = flagChange;

    if (newState.openModalCount < newState.maxOpenModalLimit) {
      if (!newFlags[modalId]) {
        newFlags[modalId] = true;
        newState.openModalCount += 1;
      }
    } else {
      newState.modalQueue = newState.modalQueue.enqueue(modalId);
    }
  });

  newState.flags = newFlags;

  return newState;
}

export {
  updateModalFlags,
};
